import React from 'react';
import { ChevronDown } from 'lucide-react';
import SecFilingCategoryDonut from './SecFilingCategoryDonut';

export default function SecFilingInsightsCompanyCard({
  card,
  chartIndex = 0,
  animateEnter = false,
  periodSwitchVersion = 0,
  isTableFilterActive = false,
  onViewFilings,
}) {
  const {
    displayName,
    isSubject,
    companyName,
    alert,
    categoryCounts,
    total,
    lastFilingDisplay,
  } = card;
  const showCriticalAlert = alert?.tone === 'critical';

  return (
    <article
      className="sec-filing-insights-card"
      aria-label={`${displayName} filings`}
    >
      <header className="sec-filing-insights-card__head">
        <div className="sec-filing-insights-card__name">{displayName}</div>
        {showCriticalAlert ? (
          <span className={`sec-filing-insights-alert sec-filing-insights-alert--${alert.tone}`}>
            {alert.text}
          </span>
        ) : null}
      </header>

      <div className="sec-filing-insights-card__section">
        {/* <div className="sec-filing-insights-card__section-title">Filings Summary</div> */}
        <div className="sec-filing-insights-card__chart-block">
          {/* <div className="sec-filing-insights-card__chart-label">Filings by category</div> */}
          <SecFilingCategoryDonut
            critical={categoryCounts.critical}
            nonCritical={categoryCounts.nonCritical}
            total={total}
            companyKey={companyName}
            chartIndex={chartIndex}
            animate={animateEnter || periodSwitchVersion > 0}
            periodSwitchVersion={periodSwitchVersion}
          />
        </div>
      </div>

      <footer className="sec-filing-insights-card__foot">
        <div className="sec-filing-insights-card__foot-date">
          <div className="sec-filing-insights-card__foot-date-label">Last Filing</div>
          <div className="sec-filing-insights-card__foot-date-val">{lastFilingDisplay}</div>
        </div>
        <button
          type="button"
          className={[
            'sec-filing-insights-card__view-btn',
            isTableFilterActive ? 'is-active' : '',
          ].filter(Boolean).join(' ')}
          onClick={() => onViewFilings?.(companyName)}
          aria-label={`View filings for ${displayName}`}
          aria-pressed={isTableFilterActive}
          title="View filings"
        >
          <ChevronDown size={14} strokeWidth={2} aria-hidden />
        </button>
      </footer>
    </article>
  );
}
